import React from 'react';

import './BlockRatio.css';

const BlockRatio = ({ ratio, style, className, contentStyle, children }) => {
  const wrapperProps = {
    className: 'block-ratio-'+(ratio ? ratio : '1_1')
  }
  if (className) wrapperProps.className += (className ? ' '+className : '');
  if (style) wrapperProps.style = style;
  // if (key) wrapperProps.key = key;
  return (
    <div {...wrapperProps}>
      <div className="block-ratio-dummy"></div>
      <div className="block-ratio-content" style={contentStyle}>{children}</div>
    </div>
  );
}

export default BlockRatio;



// WEBPACK FOOTER //
// ./src/components/BlockRatio/BlockRatio.jsx